import HomePage from 'components/pages/HomePage';
export default HomePage;
